import Sidebar from './Sidebar.vue';

export * from './components';
export default Sidebar;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/index.ts